import React from 'react';

import { RadioButtonPanels } from '@eika/radio-button';

import { HardBlockReason, SiteCoreDictionary } from '../types';
import { getReasonOptions } from './functions';

import './Form.scss';

interface FormProps {
    possibleReasons: HardBlockReason[];
    selectedReason: HardBlockReason | undefined;
    setSelectedReason: (reason: HardBlockReason | undefined) => void;
    selectedReasonError: string | undefined;
    dictionary: SiteCoreDictionary;
}

const Form = ({ possibleReasons, selectedReason, setSelectedReason, selectedReasonError, dictionary }: FormProps) => {
    const { blockStep1Legend } = dictionary;

    const REASON_OPTIONS = getReasonOptions(possibleReasons, dictionary);

    return (
        <>
            <RadioButtonPanels
                name="hvorfor-vil-du-sperre-kort"
                label={blockStep1Legend}
                onChange={(value: string) => setSelectedReason(value as HardBlockReason)}
                selectedOption={selectedReason}
                options={REASON_OPTIONS}
                errorMessage={selectedReasonError}
            />
        </>
    );
};

export default Form;
